import React, { useState, useEffect } from 'react';
import { Crown, ChevronLeft, ChevronRight } from 'lucide-react';
import { api, inr } from '../api';

const shiftMonth = (ym, delta) => {
  const [y, m] = ym.split('-').map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

const monthLabel = (ym) => {
  const [y, m] = ym.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString('en-IN', { month: 'long', year: 'numeric' });
};

export default function WallOfFame() {
  const now = new Date();
  const [month, setMonth] = useState(`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`);
  const [crowns, setCrowns] = useState([]);

  useEffect(() => {
    api.get(`/leaderboard/history?month=${month}`).then((r) => setCrowns(r.data.crowns));
  }, [month]);

  return (
    <div data-testid="wall-of-fame">
      <div className="flex items-center gap-3 mb-3 flex-wrap">
        <h3 className="font-display font-bold text-lg text-slate-800 flex items-center gap-2"><Crown size={17} className="text-yellow-500" /> Wall of Fame</h3>
        <div className="flex items-center gap-1 bg-slate-100 border-2 border-slate-200 rounded-full px-1 py-0.5">
          <button data-testid="fame-prev-month" onClick={() => setMonth(shiftMonth(month, -1))} className="p-1 rounded-full hover:bg-white text-slate-500"><ChevronLeft size={14} /></button>
          <span className="text-xs font-bold text-slate-700 px-1" data-testid="fame-month-label">{monthLabel(month)}</span>
          <button data-testid="fame-next-month" onClick={() => setMonth(shiftMonth(month, 1))} className="p-1 rounded-full hover:bg-white text-slate-500"><ChevronRight size={14} /></button>
        </div>
        <p className="font-hand text-base text-slate-400">daily crown winners 👑</p>
      </div>

      {crowns.length === 0 ? (
        <div className="bg-white border-2 border-slate-200 rounded-xl sticky-shadow p-6 text-center">
          <p className="text-3xl mb-1">🏆</p>
          <p className="font-hand text-xl text-slate-400">No crowns this month yet — the throne awaits!</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3" data-testid="fame-grid">
          {crowns.map((c) => (
            <div key={c.date} data-testid={`fame-card-${c.date}`}
              className="relative bg-gradient-to-br from-amber-50 to-yellow-100 border-2 border-amber-300 rounded-xl p-3 sticky-shadow rotate-[-0.4deg] hover:rotate-0 hover:-translate-y-0.5 transition-transform">
              <span className="absolute -top-2.5 -right-1.5 text-xl rotate-12">👑</span>
              <p className="font-display font-extrabold text-2xl text-amber-900 leading-none">{Number(c.date.slice(-2))}</p>
              <p className="text-[9px] font-bold uppercase tracking-widest text-amber-600 mb-2">{new Date(c.date).toLocaleDateString('en-IN', { weekday: 'short' })}</p>
              <div className="flex items-center gap-2">
                <span className="w-7 h-7 rounded-full flex items-center justify-center text-[9px] font-extrabold text-slate-800 border border-white shadow-sm shrink-0" style={{ background: c.avatar_color }}>
                  {c.agent_name.split(' ').map((w) => w[0]).join('')}
                </span>
                <div className="min-w-0">
                  <p className="text-xs font-bold text-slate-900 truncate">{c.agent_name}</p>
                  <p className="text-[10px] font-extrabold text-amber-700">{inr(c.amount)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
